import React from 'react';
import PropTypes from 'prop-types';
import FieldGroup from '../../common/forms/FieldGroup';
import SubmitButton from '../../common/forms/SubmitButton';
import SubmitSpinner from '../../common/Spinners/SubmitSpinner';
import FailureFaceMessage from '../../common/FailureFaceMessage';
import { Form } from 'react-bootstrap';
import * as styles from './_AdministrationLogin.scss';
import withStyles from 'isomorphic-style-loader/withStyles';

const AdministrationLogin = ({
  isInvalid,
  emailAddress,
  password,
  submitting,
  login,
  loginFailed,
  emailAddressChange,
  passwordChange,
  resetPassword
}) => (
  <div className={styles.wrapper}>
    <h1 className={styles.heading}>Administrator Login</h1>

    <form
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        login();
      }}
    >
      <FieldGroup
        required
        type="email"
        value={emailAddress}
        handleChange={emailAddressChange}
        placeholder="Email address"
        label="Email address"
        message={isInvalid.emailAddress.help}
        isInvalid={isInvalid.emailAddress.isInvalid}
      />

      <FieldGroup
        required
        type="password"
        value={password}
        handleChange={passwordChange}
        placeholder="Password"
        label="Password"
        message={isInvalid.password.help}
        isInvalid={isInvalid.password.isInvalid}
      />

      <Form.Group>
        <SubmitButton
          buttonText="Login"
          isValid={isInvalid.formIsValid}
          isSubmitting={submitting}
        />
        {submitting && <SubmitSpinner />}
        {loginFailed && (
          <FailureFaceMessage message="Email address and/or password incorrect." />
        )}
      </Form.Group>

      <Form.Group>
        <p>
          Forgot your password?{' '}
          <a href="" onClick={resetPassword} className={styles.reset}>
            Reset your password.
          </a>
        </p>
      </Form.Group>
    </form>
  </div>
);

AdministrationLogin.propTypes = {
  isInvalid: PropTypes.object.isRequired,
  emailAddress: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  loginFailed: PropTypes.bool.isRequired,
  login: PropTypes.func.isRequired,
  emailAddressChange: PropTypes.func.isRequired,
  passwordChange: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired
};

export default withStyles(styles)(AdministrationLogin);